<template>
  <div id="app">
    <Header/>
    <router-view class="routerview"/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  components: {Header, Footer},
  name: 'App'
}
</script>

<style>
*{ margin:0; padding:0;}
.clear{ clear:both;}
a{ text-decoration:none; cursor:pointer;color:#333;}
li{ list-style:none;}
input{outline:medium;}
body{ width:100%;font-family:微软雅黑; background:#fff;}
html{overflow-x: hidden;}
.fr{ float:right;}
.le{ float:left;}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#content{
  margin-top: 96px;
  min-height: 600px;
  height: auto;
}
.routerview{
  min-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue